export const CERTIFICABILITY_TYPES = {
  eligible: {
    value: 'eligible',
    translate: 'pages.sco-organization-participants.table.column.is-certifiable.eligible',
  },
  'non-eligible': {
    value: 'non-eligible',
    translate: 'pages.sco-organization-participants.table.column.is-certifiable.non-eligible',
  },
  'not-available': {
    value: 'not-available',
    translate: 'pages.sco-organization-participants.table.column.is-certifiable.not-available',
  },
};
